import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import '@clr/icons';
import '@clr/icons/shapes/all-shapes';
import { ClarityModule } from "@clr/angular";
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';

/*
 * Platform and Environment providers/directives/pipes
 */
import { environment } from 'environments/environment';
import { ROUTES } from './app.routes';

import { AuthModule } from './auth';
import { ConfigsModule } from './configs';

import { LoginModule } from './login';


// App is our top level component
import { AppComponent } from './app.component';

import '../styles/styles.scss';


registerLocaleData(localeFr, 'fr');

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ AppComponent ],
  declarations: [
    AppComponent,
  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(ROUTES, {
      useHash: Boolean(history.pushState) === false,
      preloadingStrategy: PreloadAllModules
    }),

    ClarityModule,
    SnotifyModule,

    AuthModule.forRoot(),
    ConfigsModule.forRoot(),
    LoginModule,
  ],

  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],

  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [
    environment.ENV_PROVIDERS,
    { provide: LOCALE_ID, useValue: 'fr' },
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults},
    SnotifyService,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts